import { FlexBox } from '@thewhite/react-flex-layout';
import classnames from 'classnames';
import * as React from 'react';
import { WsReactBaseComponent, WsReactBaseComponentInterface } from '@thewhite/react-base-components';
import ReactSVG from 'react-svg';
import { AuthService } from '../../../Auth/services/authServices';
import { MainMenuItem } from '../../interfaces/MainMenuItem';
import { MainMenuService } from '../../services/mainMenuService';
import { MainMenuItemChild } from '../../interfaces/MainMenuItemChild';

interface MainMenuProps {
    pathName: string;
}

interface MainMenuState {
    parentId: number | null;
}

interface MainMenuParams extends WsReactBaseComponentInterface {
    props: MainMenuProps;
    state: MainMenuState;
    menuItems: MainMenuItem[];

    isSelectFamily(family: string | string[], notFamily?: string | string[]): boolean;
}

export class MainMenu extends WsReactBaseComponent<MainMenuProps, MainMenuState> implements MainMenuParams {
    menuItems = MainMenuService.menuItems
        .filter((item: MainMenuItem) => !item.hide);
    state: MainMenuState = {
        parentId: null,
    }

    /**
     * Я нахожусь в этом разделе
     */
    isSelectFamily(family: string | string[], notFamily: string | string[] = []): boolean {
        if (!family) return false;

        let find = false;
        let arrayFamily: string[] = family instanceof Array
            ? family
            : [family];
        let arrayNotFamily: string[] = notFamily instanceof Array
            ? notFamily
            : [notFamily];

        find = arrayFamily.some((item: string) => document.location.hash.indexOf(item) > -1);
        arrayNotFamily.forEach((item: string) => {
            if (document.location.hash.indexOf(item) > -1) find = false;
        });

        return find;
    }

    /**
     * Открыть/закрыть список детей
     * @param parentId
     */
    openOrCloseListChildren = (parentId: number | null) => {
        this.setState({
            parentId: this.state.parentId !== parentId
                ? parentId
                : null,
        });
    }

    /**
     * Активный пункт меню
     * @param item
     */
    activeMenuItem = (item: MainMenuItem): boolean => {
        return this.isSelectFamily(item.family, item.notFamily) &&
            (!item.children?.length || !this.state.parentId || item.id !== this.state.parentId);
    }

    render(): false | JSX.Element | JSX.Element[] {
        return (
            <FlexBox
                grow={'1'}
                node={'nav'}
                className={'main-menu'}
            >
                <FlexBox
                    <HTMLUListElement>
                    node={'ul'}
                    column={'start'}
                    className={'main-menu__list'}
                >
                {
                    this.menuItems.map((item: MainMenuItem, index: number) => {
                        return (
                            <React.Fragment
                                key={index}
                            >
                                <li
                                    key={item.name}
                                    className={classnames(
                                        'main-menu__list-item',
                                        {
                                            'main-menu__list-item--active': this.activeMenuItem(item),
                                        },
                                    )}
                                >
                                    <FlexBox
                                        <HTMLAnchorElement>
                                        node={'a'}
                                        row={'sb ctr'}
                                        href={
                                            !item.children?.length
                                                ? !item.targetBlank
                                                    ? `#${item.routePath}`
                                                    : item.routePath
                                                : undefined
                                        }
                                        className={classnames(
                                            'main-menu__list-item-link',
                                            'label-2-primary',
                                        )}
                                        target={
                                            item.targetBlank
                                                ? '_blank'
                                                : undefined
                                        }
                                        onClick={() => item.children?.length && this.openOrCloseListChildren(item.id)}
                                    >
                                        <FlexBox
                                            row={'start ctr'}
                                        >
                                            <ReactSVG
                                                className={'main-menu__list-item-link-icon-wrapper'}
                                                src={item.iconPath ?? ''}
                                                svgClassName={'main-menu__list-item-link-icon'}
                                            />
                                            {item.visibleName}
                                        </FlexBox>
                                        {
                                            !!item.children?.length &&
                                                <ReactSVG
                                                    svgClassName={'main-menu__list-item-link-icon'}
                                                    src={`assets/images/svg/arrow-${item.id === this.state.parentId ? 'up' : 'down'}.svg`}
                                                />
                                        }
                                    </FlexBox>
                                </li>
                                {
                                    !!item.children?.length &&
                                    item.id === this.state.parentId &&
                                    item.children
                                        .filter((el: MainMenuItemChild) => !el.hide)
                                        .map((child: MainMenuItemChild) => {
                                            return (
                                                <li
                                                    key={child.name}
                                                    className={classnames(
                                                        'main-menu__list-item',
                                                        {
                                                            'main-menu__list-item--active': this.isSelectFamily(child.family, child.notFamily),
                                                        },
                                                    )}
                                                >
                                                    <FlexBox
                                                        <HTMLAnchorElement>
                                                        node={'a'}
                                                        row={'start ctr'}
                                                        href={
                                                            !child.targetBlank
                                                                ? `#${child.routePath}`
                                                                : child.routePath
                                                        }
                                                        className={classnames(
                                                            'main-menu__list-item-link--child',
                                                            'main-menu__list-item-link',
                                                            'label-2-primary',
                                                        )}
                                                        target={
                                                            child.targetBlank
                                                                ? '_blank'
                                                                : undefined
                                                        }
                                                    >
                                                        <ReactSVG
                                                            className={'main-menu__list-item-link-icon-wrapper'}
                                                            src={child.iconPath}
                                                            svgClassName={'main-menu__list-item-link-icon'}
                                                        />
                                                        {child.visibleName}
                                                    </FlexBox>
                                                </li>
                                            );
                                        })
                                }
                            </React.Fragment>
                        );
                    })
                }
                    <li
                        className={'main-menu__list-item'}
                    >
                        <FlexBox
                            <HTMLAnchorElement>
                            node={'a'}
                            row={'start ctr'}
                            href={'#'}
                            className={classnames(
                                'main-menu__list-item-link',
                                'label-2-primary',
                            )}
                            onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                event.preventDefault();
                                AuthService.logOut();
                            }}
                        >
                            <ReactSVG
                                className={'main-menu__list-item-link-icon-wrapper'}
                                src={'assets/images/svg/sign-out.svg'}
                                svgClassName={'main-menu__list-item-link-icon'}
                            />
                            <span>Выход</span>
                        </FlexBox>
                    </li>
                </FlexBox>
            </FlexBox>
        );
    }
}
